import { render, staticRenderFns } from "./TableOfContentsItem.vue?vue&type=template&id=e9c5f78c&scoped=true"
import script from "./TableOfContentsItem.vue?vue&type=script&lang=js"
export * from "./TableOfContentsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c5f78c",
  null
  
)

export default component.exports